var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 117.364,
    viewBox: "0 0 100 117.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#0c8591;}.c{fill:#d99448;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.82,
    y1: 1.52,
    x2: 0.431,
    y2: 0.091,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c8794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f4e90"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-178.422 -120.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.422 136.445)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256.673,283.674l-44.277-27.7v62.667l44.663,28.078,44.663-28.078V255.979Z",
    transform: "translate(-207.059 -250.642)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M228.422,323.424a5.115,5.115,0,0,1-2.726-.785l-44.908-28.252a5.048,5.048,0,0,1-2.367-4.271V227.061a5.05,5.05,0,0,1,2.632-4.427,5.126,5.126,0,0,1,5.176.15l41.827,26.182,42.59-26.2a5.124,5.124,0,0,1,5.159-.12,5.05,5.05,0,0,1,2.615,4.417v63.055a5.048,5.048,0,0,1-2.367,4.271l-44.908,28.252A5.114,5.114,0,0,1,228.422,323.424Zm-39.816-36.089,39.816,25.048,39.815-25.048V236.142l-37.521,23.084a5.124,5.124,0,0,1-5.4-.021l-36.711-22.979Z",
    transform: "translate(-178.422 -222.005)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M370.035,144.964l8.688-5.278,17.637,11.021,6.744-10.792-17.97-11.229V120.5H372.407v8.133L354.6,139.45l-.067,10.835,33.531,20.943-9.679,6-17.8-11.22L353.8,176.771l21.161,13.341,6.745.026,21.755-13.48.019-10.806Z",
    transform: "translate(-150.228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(183.057 135.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.577 28.228)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M496.637,433.278a.818.818,0,0,1-.438-.127l-2.084-1.314.876-1.389,1.649,1.04,1.658-1.027.865,1.4-2.094,1.3A.818.818,0,0,1,496.637,433.278Z",
    transform: "translate(-494.115 -430.449)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.33 3.875)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M282.985,298.729l-3.863-2.435.875-1.389,3.863,2.435Zm-7.725-4.871-3.863-2.435.876-1.389,3.863,2.435Zm-7.725-4.871-3.863-2.435.876-1.389,3.863,2.435Zm-7.725-4.871-3.863-2.435.876-1.389,3.863,2.435Zm-7.726-4.87-3.863-2.435.876-1.389,3.863,2.435Z",
    transform: "translate(-248.22 -275.423)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M209.569,254.038h-1.642v-2.463a.821.821,0,0,1,1.259-.694l2.084,1.314-.876,1.389-.825-.52Z",
    transform: "translate(-207.927 -250.754)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.025)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M209.569,353.991h-1.642V349.25h1.642Zm0-9.482h-1.642v-4.741h1.642Zm0-9.482h-1.642v-4.741h1.642Zm0-9.482h-1.642V320.8h1.642Zm0-9.482h-1.642v-4.741h1.642Zm0-9.482h-1.642V301.84h1.642Z",
    transform: "translate(-207.927 -301.84)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 64.917)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M210.389,668.48l-2.081-1.318a.82.82,0,0,1-.382-.694v-2.463h1.642v2.011l1.7,1.076Z",
    transform: "translate(-207.927 -664.005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.362 70.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M283.532,723.025l-3.9-2.472.879-1.387,3.9,2.472Zm-7.8-4.943-3.9-2.472.879-1.387,3.9,2.472Zm-7.8-4.943-3.9-2.472.879-1.387,3.9,2.472Zm-7.8-4.943-3.9-2.472.879-1.387,3.9,2.472Zm-7.8-4.943-3.9-2.472.879-1.387,3.9,2.472Z",
    transform: "translate(-248.429 -699.395)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.964 95.19)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M499.236,859.553a.818.818,0,0,1-.439-.128l-2.08-1.318.879-1.387,1.641,1.04,1.641-1.04.879,1.387-2.081,1.318A.818.818,0,0,1,499.236,859.553Z",
    transform: "translate(-496.716 -856.72)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.624 70.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M548.912,723.022l-.879-1.387,3.9-2.472.879,1.387Zm7.8-4.943-.879-1.387,3.9-2.472.879,1.387Zm7.8-4.943-.879-1.387,3.9-2.472.879,1.387Zm7.8-4.943-.879-1.387,3.9-2.472.879,1.387Zm7.8-4.943-.879-1.387,3.9-2.472.879,1.387Z",
    transform: "translate(-548.033 -699.392)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.627 64.917)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M797.2,668.48l-.879-1.387,1.7-1.076v-2.011h1.642v2.463a.82.82,0,0,1-.382.694Z",
    transform: "translate(-796.32 -664.005)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89.326 8.025)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M808.778,353.991h-1.642V349.25h1.642Zm0-9.482h-1.642v-4.741h1.642Zm0-9.482h-1.642v-4.741h1.642Zm0-9.482h-1.642V320.8h1.642Zm0-9.482h-1.642v-4.741h1.642Zm0-9.482h-1.642V301.84h1.642Z",
    transform: "translate(-807.136 -301.84)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(87.621 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M799.628,254.038h-1.642v-.989l-.84.521-.865-1.4,2.094-1.3a.821.821,0,0,1,1.253.7Z",
    transform: "translate(-796.281 -250.754)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.272 3.858)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M546.658,298.656l-.865-1.4,3.935-2.438.865,1.4Zm7.87-4.877-.865-1.4,3.935-2.438.865,1.4Zm7.87-4.876-.865-1.4,3.935-2.438.865,1.4Zm7.869-4.877-.865-1.4,3.935-2.438.865,1.4Zm7.87-4.876-.865-1.4,3.935-2.438.865,1.4Z",
    transform: "translate(-545.793 -275.316)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.16f175d1cb3c29b29c060bbfddd345f6.svg";
export { ForwardRef as ReactComponent };